import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';
import {
	Card,
	TranslatedString,
	useAjax,
	XhrStatus,
	Form,
	PrimaryButton,
	Table,
	makeColumnHeader
} from '@bosch/bt-ui';

import './SimBatchDeactivatePage.css';
import withErrorHandler from '../../components/ErrorHandler';
import ConfirmDialog from '../../components/ConfirmDialog';
import CenterLoadingContainer from '../../components/CenterLoadingContainer';
import { prepareLogData } from '../../components/Util';

const TABLE_HEADERS = [
	makeColumnHeader('iccid', 'ICCID'),
	makeColumnHeader('status', 'Status')
];

function makeRow(task) {
	const {
		iccid,
		status
	} = task;

	return {
		key: iccid,
		columns: [
			{
				key: 'iccid',
				columnContent: iccid
			},
			{
				key: 'status',
				columnContent: status
			}
		],
		htmlAttributes: {
			className: status.startsWith('Ready') ? 'iccid-ready-row' : status.startsWith('Success') ? 'iccid-success-row' : 'iccid-error-row'
		}
	};
}

const SimBatchDeactivatePage = (props) => {
	const {
		token
	} = props;

	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);
	const [openConfirm, setConfirmOpen] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(true);

	const onCleanFile = (e) => { e.target.value = null };
	const onFileChange = (e) => {
		var reader = new FileReader();
		reader.onload = function () {
			const headers = {
				'Authorization': 'Bearer ' + token.token
			}
			const simLongString = reader.result

			runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/batchupload', null, simLongString, headers);
		}
		reader.readAsText(e.target.files[0]);
	};

	const onOpenModal = () => setConfirmOpen(true);
	const onFormSubmit = useCallback(
		() => {
			const headers = {
				'Authorization': 'Bearer ' + token.token
			}
			const iccids = returnResult.data.map(item => item.iccid); 
			const iccidString = iccids.join(','); 
			const data = prepareLogData(token,'SIM_Management', 'Batch deactivates sim cards(100 max SIMs per file) -> Deactivate '+ iccidString); 
			setConfirmOpen(false);
			setSubmitDisable(true);
			runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/batchdeactivation', null, returnResult.data, headers);

			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })		
		},
		[returnResult, runAjaxInner, token.token]
	);

	const rows = useMemo(
		() => {
			if (!returnResult)
				return null;

			const unfilteredRows = returnResult?.data?.map(item => makeRow(item));

			return unfilteredRows;
		},
		[returnResult]
	);

	useEffect(() => {
		console.log('SimBatchDeactivatePage==========>')
		console.log(response)
		console.log(returnResult)

		if (returnResult && returnResult?.status === 'Success') {
			setSubmitDisable(false);
		}
		else {
			setSubmitDisable(true);
		}
	}, [returnResult, response]);

	return (
		<Card
			htmlAttributes={{
				id: 'sim-batch-deactivate',
				className: 'sim-batch-deactivate-page'
			}}
		>
			<div className="caption font-large"><TranslatedString stringId="caption-sim-batch-deactivate" /></div>
			<div><TranslatedString stringId="note-sim-batch-deactivate" /></div>
			{
				status === XhrStatus.InProgress ?
					<CenterLoadingContainer />
					:
					<div>
						<Table
							headers={TABLE_HEADERS}
							rows={rows}
							htmlAttributes={{
								className: 'iccid-table'
							}}
							isLoading={false}
							noResultsMessage={<TranslatedString stringId="No items found" />}
							errorMessage=''
						/>
					</div>
			}
			<Form
				formAttributes={{
					onSubmit: onOpenModal,
					method: 'post',
					action: ''
				}}
			>
				<div className="sim-batch-deactivate-body">
					<input className="file-upload" type="file" onChange={onFileChange} onClick={onCleanFile}></input>
					<PrimaryButton type="sumit" disabled={disableSubmit}>
						<TranslatedString stringId="button-deactivate" />
					</PrimaryButton>
					<ConfirmDialog openConfirm={openConfirm} setConfirmOpen={setConfirmOpen} onConfirm={onFormSubmit} />
				</div>
			</Form>
		</Card>
	);
};

export default withErrorHandler(React.memo(SimBatchDeactivatePage));